import { useRef, useEffect } from 'react';
/**
 * A React hook to manage event listeners
 *
 * @param eventName the event name
 * @param handler the event handler function to execute
 * @param element the element to add the event listener to.
 * If not defined, the event listener will be added to window by default
 * @param listen if true, the event listener will be added to the specified element or window
 */
export const useEventListener = (eventName, handler, element, listen = true) => {
    const savedHandler = useRef();
    useEffect(() => {
        const targetElement = element?.current || window;
        if (!(targetElement && targetElement.addEventListener) || !listen) {
            return;
        }
        if (savedHandler.current !== handler) {
            savedHandler.current = handler;
        }
        const eventListener = (event) => {
            if (savedHandler?.current) {
                savedHandler.current(event);
            }
        };
        targetElement.addEventListener(eventName, eventListener);
        return () => {
            targetElement.removeEventListener(eventName, eventListener);
        };
    }, [eventName, element, handler, listen]);
};
